import React from 'react';

import { DesktopOnly, MobileOnly } from 'shared/components';
import { ModalWrapper } from 'shared/modals/v2-wrapper';
import type { PosOrderFieldsFragment } from 'src/gql/graphql';
import { withModalControlsHook, ModalComponentProps } from 'src/components/modals/with-modal-controls-hook';

import { InstoreReceiptDesktop } from './instore-receipt-desktop';
import { InstoreReceiptMobile } from './instore-receipt-mobile';

export type InstoreOrderReceiptModalData = {
  posOrder: PosOrderFieldsFragment;
};

type InstoreOrderReceiptModalProps = ModalComponentProps<InstoreOrderReceiptModalData>;

const InstoreOrderReceiptModal = ({ open, onClose, data }: InstoreOrderReceiptModalProps): JSX.Element => {
  const { posOrder } = data;

  return (
    <ModalWrapper open={open} onClose={onClose}>
      <>
        <DesktopOnly>
          <InstoreReceiptDesktop posOrder={posOrder} onClose={onClose} />
        </DesktopOnly>
        <MobileOnly>
          <InstoreReceiptMobile posOrder={posOrder} onClose={onClose} />
        </MobileOnly>
      </>
    </ModalWrapper>
  );
};

const [
  InstoreOrderReceiptController,
  useInstoreOrderReceiptModal,
] = withModalControlsHook<InstoreOrderReceiptModalData>(InstoreOrderReceiptModal);

export { useInstoreOrderReceiptModal, InstoreOrderReceiptController };
